import appCorporateContractApprovals from "../../views/appSettings/corporateContractApprovals.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "corporate-contract-approvals";
  const params = [
    "page', 'limit",
    "status",
    "corporate",
    "start_date",
    "end_date",
    "date",
    "sort",
  ];

  $stateProvider.state("corporatecontractapprovals", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCorporateContractApprovals,
      },
    },
    reloadOnSearch: false,
    data: { title: "CorporateContractApprovals" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporateContractApprovals/corporateContractApprovals.urls.js